import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import { store } from './store';
import VuetifyConfirm from 'vuetify-confirm'
import VueFlags from "@growthbunker/vueflags";
import VueViewer from 'v-viewer'
Vue.use(VueFlags,{
  iconPath: '/flags/',
});
Vue.use(VueViewer);
Vue.config.productionTip = false;
Vue.prototype.$API =  "https://backend-owner.egmokka.com";
Vue.prototype.$Version =  "v1.250501";
Vue.use(VuetifyConfirm, { vuetify })
new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
